

import './JobItem.css';
import { Link } from 'react-router-dom';
import { getEmploymentTypes, getWorkPlaces } from '../../Javascript_Functions_to_export/Utils';
import { useState, useEffect } from 'react';

import { showLocalTime } from '../../Javascript_Functions_to_export/Utils';

import { isValidToken } from '../../Javascript_Functions_to_export/Utils';
import Cookie from 'js-cookie';


const JobItem = ({ _jobItem}) => {

    const [employmentTypes, setEmploymentTypes] = useState();
    const [workPlaces, setWorkPlaces] = useState();

    const loggedInIconBase64 = "data:@file/png;base64,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"; 

    //console.log("item", _jobItem);

    useEffect(() => {

        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }


        setEmploymentTypes(getEmploymentTypes());
        setWorkPlaces(getWorkPlaces());

        
        window.scrollTo(0, 0);

    }, []);

    //  {`input ${!company ? "red-border" : "green-border"}`}
    // font awesome: pin code: <i className="fa fa-thumb-tack" aria-hidden="true"></i>
    return(

        // <div className='single-job-row'> old code
        <div>
            {/* <div className='item-background'>

            </div> */}
            <Link to={`/job/details/${_jobItem.JobID}`} className='single-job-row'>
            
              {/* className={`single-job-row ${ _jobItem.Featured === 1 ? 'feature' : '' }`} > */}
                {/* Pin(aka thumbtack) Icon if featured */}
                {/* {
                    _jobItem.Featured === 1 && 
                    <i className="fa fa-thumb-tack" 
                   aria-hidden="true"
                   style={{ position: 'relative', 
                            // transform: 'rotate(318deg)',
                            transform: 'rotate(315deg)',   
                            //rgb(0 135 255 / 8%);
                            color: '#ff0000b5',
                            fontSize: '23px',
                            top: '-77px',
                            left: '-5px', }}></i>
                } */}

                <div className='col1'>
                {/* <div className={`col1 ${ _jobItem.Featured === 1 ? 'move-left' : '' } `}> */}
                    {/* <img src={`./comp${_key + 1}.JPG`}   */}
                    {
                        _jobItem.IsConfidential ?
                        <i className="fa fa-shield" 
                            aria-hidden="true" 
                            style={{ fontSize: '165px', color: "black"}}></i>
                        :
                        _jobItem.Logo !== loggedInIconBase64 ?
                            // <img src={ "/" + _jobItem.Logo } 
                            <img src={ _jobItem.Logo } 
                                alt="Company Logo"
                                className='company-logo' /> 
                        :
                        //_jobItem.Logo === loggedInIconBase64 && !_jobItem.IsConfidential ?
                            <i className="fa fa-picture-o" 
                            aria-hidden="true"
                            style={{ fontSize: '125px', opacity: '0.2', color: "gray"}}>
                            </i>
                    }
                </div>
                
                <div className='col2'>
                    <div className='title'>
                        {/* <Link to={`/job/details/${_jobItem.JobID}`} > */}
                            { 
                                _jobItem && 
                                _jobItem.JobTitle &&

                                (_jobItem.JobTitle.length <= 40 ? 
                                _jobItem.JobTitle : 
                                _jobItem.JobTitle.slice(0, 30) + "...")
                            }
                        {/* </Link> */}
                    </div>
                    <div className='location'>
                        { 
                            // typeof(_jobItem.Location) + '  ' + _jobItem.Location 

                            _jobItem && 
                            _jobItem.Location &&

                            (_jobItem.Location === 'null' || 
                            _jobItem.Location === null || 
                            _jobItem.Location.trim() === '' ?
                            'Location: not specified' :
                            _jobItem.Location)
                        }
                        {/* <span style={{ display: 'inline-block', 
                                       borderRadius: '50%',
                                       background: '#10bd10',
                                       width: '7px',
                                       height: '7px', 
                                       margin: '0 5px 0 8px' }}></span> */}
                        {/* <span className='workplace'>
                        { 
                            workPlaces && _jobItem && 
                            workPlaces.find(g => g.Id === _jobItem.Workplace) ?
                            workPlaces.find(g => g.Id === _jobItem.Workplace).Name : 
                            <span className='unknown-val'></span> 
                        }
                        </span> */}
                    </div>  
                    <div className='company-name'>Company:&nbsp;
                        { 
                            _jobItem && _jobItem.IsConfidential === 1 ? 
                            'Confidential' : 
                            _jobItem && _jobItem.CompanyName 
                        } 
                    </div>  
                </div>

                <div className='col3'>
                    <div className='employment-type'>
                    { 
                        workPlaces && _jobItem && 
                        _jobItem.Workplace === 10 && workPlaces.find(g => g.Id === _jobItem.Workplace) ? 
                        'Place: ' + workPlaces.find(g => g.Id === _jobItem.Workplace).Name 
                        :
                        workPlaces && _jobItem &&
                        workPlaces.find(g => g.Id === _jobItem.Workplace) ?
                        workPlaces.find(g => g.Id === _jobItem.Workplace).Name
                        :
                        <span className='unknown-val'></span> 
                    }
                    </div>
                    <div className='salary'>
                        Salary : { _jobItem && !_jobItem.Salary ? 
                                   'Not Specified' : 
                                   _jobItem && _jobItem.Salary }
                    </div> 
                   
                    { 
                        _jobItem && _jobItem.PostingDate &&
                        
                        (<div className={`postingdate ${ showLocalTime(_jobItem).PostingDate && 
                                                        showLocalTime(_jobItem).PostingDate.indexOf('ago') >= 0 ? ' red-date' : ' blue-date' }`}>
                            { showLocalTime(_jobItem).PostingDate }
                            {/* { _jobItem.PostingDate } */}
                        </div>)
                    }
                </div>

            </Link>
        </div>
    )
}

export default JobItem;